import React, { useEffect, useRef, useState } from 'react';
import intl from '$intl';
import { IonContent, IonFooter } from '@ionic/react';

import { SPACE } from '$gstyles';
import { input } from '$gbusiness/helpers';
import { Flex, PageWrapper } from '$gstyles/wrapper';
import { Button } from '$gcomponents/primitives';
import { useDispatch } from 'react-redux';
import { serialActions } from '$fbusiness/redux/serial';
import { ScanModalWrapper } from './styles';
import ItemModel from '$fbusiness/models/item';
import { Form, Formik } from 'formik';
import { SERIAL_SCAN_FORM } from './serialForm';
import { FormSection } from '$gcomponents/reusables';
import { getAccess, isAccessible } from '$fbusiness/helpers/util';
import CurrentStateModel from '$fbusiness/models/currentState';
import { batchActions } from '$fbusiness/redux/batch';
import FactoryModel from '$fbusiness/models/factory';

interface SerialScanModalProps {
  show: boolean;
  item?: ItemModel;
  factory: FactoryModel;
  items?: Array<ItemModel>;
  currentState: CurrentStateModel;
  onClose: Function;
  onRefresh: Function;
}

const SerialScanModal: React.FC<SerialScanModalProps> = ({
  show,
  currentState,
  items,
  item,
  factory,
  onRefresh,
  onClose,
}) => {
  const dispatch = useDispatch();
  const formRef = useRef<any>();

  const [batches, setBatches] = useState([]);
  const ACCESS = getAccess(currentState);
  const warehouses = factory.warehouses || [];

  useEffect(() => {
    if (!item || !item.id) return;
    onItemChange(item.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item?.id]);

  const onItemChange = (itemId) => {
    if (!itemId) return;
    dispatch(batchActions.fetchBatches(itemId)).then((list) => {
      if (!list) return;
      setBatches(list);
    });
  };

  const onSubmit = (values) => {
    const { item, warehouseId, serials, batchId } = values;

    const param = {
      serials: (serials || '').trim().split(/[\n,]/),
      itemId: item?.id,
      warehouseId: warehouseId || undefined,
      ...(batchId && { batchId }),
    };

    dispatch(serialActions.saveSerials(param)).then((success) => {
      if (onRefresh) onRefresh();
      if (success) onClose();
    });
  };

  const serialForm = SERIAL_SCAN_FORM({ items, batches, onItemChange, warehouses });

  const validateForm = (values) => {
    return input.validateError(serialForm, values);
  };

  const initialValues = {
    ...(item && { item }),
    batchId: null,
  };

  const title = 'Add Serial by Scan';

  return (
    <ScanModalWrapper width="500px" titleText={title} show={show} onClose={() => onClose()} useCustom>
      <Formik
        innerRef={formRef}
        enableReinitialize={true}
        initialValues={initialValues}
        validate={validateForm}
        onSubmit={(values) => {
          onSubmit(values);
        }}>
        {(formik) => {
          const isFormValid = formik.isValid && formik.dirty;
          return (
            <>
              <IonContent>
                <PageWrapper>
                  <Form>
                    <FormSection
                      className="item-input-wrapper"
                      FORM={serialForm}
                      formik={formik}
                      marginBottom="30px"
                    />
                  </Form>
                </PageWrapper>
              </IonContent>
              <IonFooter>
                <Flex padding={SPACE.MEDIUM} justifyContent="space-around">
                  <Button className="third" onClick={() => onClose()} variant="outlined">
                    {intl('BUTTON.CANCEL')}
                  </Button>
                  <Button
                    className="third"
                    disabled={!isFormValid || !isAccessible(ACCESS.ACTION.SERIAL.CREATE, currentState)}
                    onClick={formik.handleSubmit}>
                    {intl('BUTTON.SUBMIT')}
                  </Button>
                </Flex>
              </IonFooter>
            </>
          );
        }}
      </Formik>
    </ScanModalWrapper>
  );
};

export default SerialScanModal;
